export default __webpack_public_path__ + "static/media/mob_preland_4.c126fc63.jpg";